// JavaScript code for acf_blocks/table-of-contents-block component
(($) => {

    "use strict";
    if ($('.acf-blocks-table-of-contents-block').length === 0) {
        return;
    }
    console.log("acf_blocks/table-of-contents-block scripts loaded...");

    if ($('.main-post').length) {
        $('.acf-blocks-table-of-contents-block').prependTo('.main-post');
    }

    const positions = {};
    const THRESHOLD = 280; // Threshold for scroll position
    const pattern = /[^\w\s.,:;!?'-]/g; // This pattern was used to remove symbols from the text

    /**
     * Scrolls to the target element smoothly on page load if there's a hash in the URL.
     */
    $(window).on('load', function() {
        if ($('.acf-blocks-table-of-contents-block a').length) {
            applyHeadingIds();
        } else {
            generateAnchorLinks();
        }
        if (! window.location.hash) return;

        let target = window.location.hash;
        scrollToTarget(target);
    });

    /**
     * On window resize, refresh the positions of the headings in the content area.
     * This is necessary to ensure that the smooth scrolling works correctly when the window is resized.
     */
    $(window).on('resize', function() {
        if ($(window).width() < Breakpoints.lgx) {
            return;
        }
        refreshPositions();
    });

    /**
     * On window scroll, check if the sidebar links should be highlighted based on the current scroll position.
     */
    $(window).on('scroll', function() {
        if ($(window).width() < Breakpoints.lgx) {
            return;
        }
        let sidebarLinks = $('.acf-blocks-table-of-contents-block a');
        let scrollTop = $(this).scrollTop() + THRESHOLD;
        const $activeLink = sidebarLinks.filter((_, link) => {
            let target = $(link).attr('href');
            return positions[target.replace('#', '')] <= scrollTop;
        }).last();
        $activeLink.parent().addClass('active').siblings().removeClass('active');
    });

    /**
     * Scrolls to the target element smoothly when a link in the sidebar is clicked.
     * Prevents default behavior and updates the URL hash without scrolling.
     */
    $('.acf-blocks-table-of-contents-block').on('click', 'a', function(e) {
        e.preventDefault();
        let target = $(this).attr('href');
        scrollToTarget(target);
        // Update the URL hash without scrolling
        if (history.pushState) {
            history.pushState(null, null, target);
        } else {
            window.location.hash = target;
        }
    });

    /**
     * Scans the main content of the page searching for headings to automatically populate
     * the Table of Contents links.
     */
    function generateAnchorLinks() {
        let htmlLinkBuilder = "";
        $('h1, h2, h3, h4, h5, h6', '.main-page-content').each(function(index, element) {
            let text = $(this).text().trim();
            let id = $(this).text().trim().replace(pattern, '').replaceAll(' ', '-').toLowerCase();
            $(this).attr('id', id);
            positions[id] = $(this).offset().top - THRESHOLD;
            htmlLinkBuilder += `
                <li class="[.active]:font-bold text-[14px] ${index === 0 ? "active" : ""}">
                    <a href="#${id}" class="flex gap-[10px] items-center justify-between">
                        ${text}
                        <svg class="shrink-0 grow-0" xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11" fill="none">
                            <path d="M9.5767 0.563228C9.53388 0.511284 9.48083 0.468936 9.42093 0.438883C9.36103 0.408831 9.2956 0.391733 9.2288 0.38868C9.16201 0.385627 9.09532 0.396686 9.03298 0.421151C8.97065 0.445617 8.91404 0.482953 8.86676 0.530778C8.81948 0.578604 8.78257 0.63587 8.75839 0.698925C8.7342 0.76198 8.72327 0.829441 8.72628 0.897008C8.7293 0.964574 8.74621 1.03076 8.77591 1.09135C8.80562 1.15195 8.84749 1.20561 8.89884 1.24893L12.3573 4.7515H0.925817C0.802414 4.75812 0.686223 4.81237 0.601188 4.90308C0.516152 4.99378 0.46875 5.11402 0.46875 5.23903C0.46875 5.36404 0.516152 5.48428 0.601188 5.57498C0.686223 5.66569 0.802414 5.71994 0.925817 5.72656H12.3573L8.89341 9.22502C8.80623 9.31737 8.75758 9.44017 8.75758 9.56787C8.75758 9.69557 8.80623 9.81836 8.89341 9.91072C8.93787 9.95583 8.9907 9.99163 9.04886 10.0161C9.10702 10.0405 9.16937 10.053 9.23235 10.053C9.29532 10.053 9.35767 10.0405 9.41583 10.0161C9.47399 9.99163 9.52682 9.95583 9.57128 9.91072L13.8554 5.57708C13.901 5.53268 13.9372 5.47943 13.962 5.42052C13.9868 5.36161 13.9996 5.29825 13.9996 5.23423C13.9996 5.17021 13.9868 5.10685 13.962 5.04794C13.9372 4.98903 13.901 4.93578 13.8554 4.89138L9.5767 0.563228Z" fill="black"/>
                        </svg>
                    </a>
                </li>
            `;
        });
        $('.acf-blocks-table-of-contents-block ol').html(htmlLinkBuilder);
    }

    /**
     * Adds IDs to headings in the content area based on the links in the sidebar.
     * This allows for smooth scrolling to the headings when the links are clicked.
     */
    function applyHeadingIds() {
        $('.acf-blocks-table-of-contents-block a').each(function () {
            let text = $(this).text().trim().replace(pattern, '');
            let id = $(this).attr('href').replace('#', '');

            if (text.length < 1) {
                return;
            }

            let position = $('h1, h2, h3, h4, h5, h6', '.main-page-content')
                .filter((_, e) => $(e).text().trim().replace(pattern, '') === text)
                .attr('id', id)
                .offset().top - THRESHOLD;

            positions[id] = position;
        });
    }

    /**
     * Refreshes the positions of the headings in the content area.
     */
    function refreshPositions() {
        for (let id in positions) {
            let position = $(`#${id}`, '.main-post .std-format-content').offset().top - THRESHOLD;
            positions[id] = position;
        }
    }

    /**
     * Function to scroll to the target element smoothly.
     * @param {string} target Target element to scroll to.
     * @returns {void}
     */
    function scrollToTarget(target) {
        let offset = positions[target.replace('#', '')] || 0;
        $('html, body').scrollTop(offset);
    }

})(jQuery);